import React, { memo, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { remove_member } from "../../redux/actions/remove_member_action";
import { Link, useNavigate } from "react-router-dom";
import  secureLocalStorage  from  "react-secure-storage";

import "../Header/index.css";


function ParticipantsDashboardHead(){
    const dispatch = useDispatch();
    const auth = useSelector((state)=>state.jwtAuthreducer);
    const member = useSelector((state)=>state.removeMemberReducer);
    const navigate = useNavigate();
    // secureLocalStorage.clear()
    const remove = ()=>{
        dispatch(remove_member())
    }

    Object.keys(secureLocalStorage).forEach((key) => {
        const value = secureLocalStorage;
        console.log(`${key}: ${value}`);
        // Perform any desired operations with the key-value pairs
      });

    useEffect(()=>{
        if(member.removed===true){
            dispatch(remove_member())
            navigate("/join")
        }
    },[member])

   

    return(
        <header class="header inner-header">
            <div class="container d-flex align-items-center">
                <a href="#" class="logo">
                    <img src={process.env.PUBLIC_URL +  'img/bedater-logo.png' } alt="" title="" width="56" />
                </a>

                <div class="ml-auto">
                    <div class="userInfo noPosition">
                        <div class="user">
                            <span>Hi,</span> {auth.user ? auth.user.username : ""}
                        </div>
                        <span  class="leaveBtn btn" onClick={()=>remove()}>Leave</span>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default ParticipantsDashboardHead;